// Phase-3 (attendance-ext, letters, policies, PF/ESIC connectors) test IDs
export const REG = {
  createBtn: "reg-create-btn",
  saveBtn: "reg-save-btn",
  approveBtn: (id) => `reg-approve-${id}`,
  rejectBtn: (id) => `reg-reject-${id}`,
  myList: "reg-my-list",
  adminList: "reg-admin-list",
};

export const SHIFT = {
  list: "shifts-list",
  createBtn: "shift-create-btn",
  saveBtn: "shift-save-btn",
  rosterList: "roster-list",
  rosterAssignBtn: "roster-assign-btn",
};

export const LETTER = {
  templates: "letter-templates",
  generateBtn: "letter-generate-btn",
  list: "letters-list",
};

export const POLICY = {
  saveBtn: "policy-save-btn",
  form: "policy-form",
};

export const CONN = {
  list: "connectors-list",
  saveBtn: "connector-save-btn",
  pfExportBtn: "pf-export-btn",
  esicExportBtn: "esic-export-btn",
  submissionsList: "submissions-list",
};
